const style = {
  backgroundColor: 'rgba(0, 0, 0, 0.1)',
  backdropFilter: 'blur(1px)',
  display: 'block'
}

const sizeClass = {
  lg: 'modal-lg',
  sm: 'modal-sm'
}

export const Modal = props => {
  const {
    size = false,
    onClose = () => {},
    onCancel = () => {},
    onConfirm = () => {},
    confirmButtonProps = {},
    cancelButtonProps = {},
    footerProps = {}
  } = props
  return (
    <div
      className={`modal fade ${props?.open ? 'show' : ''}`}
      tabIndex="-1"
      role="dialog"
      style={props?.open ? style : {}}
    >
      <div
        className={`modal-dialog ${size ? sizeClass[size] : ''} ${
          props?.center ? 'modal-dialog-centered' : ''
        }`}
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{props?.title}</h5>
            <button type="button" className="close" aria-label="Close" onClick={() => onClose()}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">{props.children}</div>

          {(props?.confirmTitle || props?.cancelTitle) && (
            <div className="modal-footer" {...footerProps}>
              {props?.confirmTitle && (
                <button type="button" className="btn btn-primary" onClick={onConfirm} {...confirmButtonProps}>
                  {props.confirmTitle}
                </button>
              )}
              {props?.cancelTitle && (
                <button type="button" className="btn btn-secondary" onClick={onCancel} {...cancelButtonProps}>
                  {props.cancelTitle}
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
